import { AppState } from '../state/AppState';

export function selectVizPath(state: AppState): string {
  return state.vizPath;
}
